// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"40":"9c963a4b","395":"f9d32c03"}[chunkId] + ".chunk.css";
};